import React, { useState } from 'react';
import Box from '@sendsprint/ui-react/dist/components/Box/Box';
import Text from '@sendsprint/ui-react/dist/components/Text/Text';
import Button from '@sendsprint/ui-react/dist/components/Button/Button';
import curvedWarningInfoImg from '@src/assets/images/curved-warning-info.png';
import Image from '@src/components/image';
import { useMedia } from '@src/hooks';
import { useDashboardContext } from '@src/contexts';

const IdExpired = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { isMobile } = useMedia();

  const { handleVeriffOpenTab, isIdExpired } = useDashboardContext();

  const handleClick = async () => {
    setIsLoading(true);
    await handleVeriffOpenTab();
    setIsLoading(false);
  };

  if (!isIdExpired) return <></>;

  return (
    <Box className="ss-bg-warning-50 ss-overflow-hidden ss-px-4 ss-flex ss-flex-col md:ss-flex-row md:ss-items-center ss-py-4 ss-gap-3 md:ss-pr-4 ss-w-full lg:ss-flex-1 ss-relative">
      <Box className="ss-flex ss-relative ss-flex-1 ss-items-center ss-gap-3">
        <Box className="">
          <Image className="ss-w-[35px] ss-h-[35px]" alt="" src={curvedWarningInfoImg} />
        </Box>
        <Box className="ss-relative ss-flex-1">
          <Text className="!ss-font-semibold">Your ID Has Expired</Text>
          <Text variant="paragraphSmall" className="">
            To keep your account secure and compliant, please update your valid ID now.
          </Text>
        </Box>
      </Box>
      <Box className="ss-relative">
        <Button
          label="Update ID Now"
          showSpinner={isLoading}
          disabled={isLoading}
          isBlock={isMobile}
          onClick={handleClick}
        />
      </Box>
    </Box>
  );
};

export default IdExpired;
